var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/**
 * omitBy - this method creates an object composed of the own and inherited enumerable string keyed properties of object that predicate doesn't return truthy for.
 *
 * @template T
 * @param {T} object
 * @param {(v: any, k: string) => boolean} predicate
 * @return {*}  {Partial<T>}
 *
 * @example
 * omitBy({ 'a': 1, 'b': '2', 'c': 3 }, (v,k) => typeof v === 'number');
 * // returns { 'b': '2' }
 *
 */
export var omitBy = function (object, predicate) {
    var obj = __assign({}, object);
    Object.entries(obj).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return predicate(value, key) && delete obj[key];
    });
    return obj;
};
//# sourceMappingURL=omitBy.js.map